import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";

import { toast } from "react-toastify";

const StationDetailsForm = (props) => {
  const [stationName, setStationName] = useState("");
  const [stationData, setStationData] = useState([]);
  const [regionId, setRegionId] = useState(0);
  const [stationCode, setStationCode] = useState("");

  const [regionData, setRegionData] = useState([]);

  const { sendRequest: poststationDetails } = useHttp();

  const { sendRequest: getstationData } = useHttp();

  const FillDetail = () => {
    getstationData(
      {
        url: `/api/station/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setStationData(res.data);
          //  console.log(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getstationData]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setRegionData(data.data);
      }
    );
  }, []);

  const submitHandler = (e) => {
    e.preventDefault();

    if (!props.update) {
      const isExistingStation = stationData.some(
        (station) => station.stationName === stationName
      );

      const isExistingCode = stationData.some(
        (station) => station.stationCode === stationCode
      );

      if (isExistingStation) {
        toast.error("Station name already exists");
        return;
      }
      if (isExistingCode) {
        toast.error("Station code already exists");
        return;
      }
    }

    const data = {
      regionId: regionId,
      stationName: stationName,
      stationCode: stationCode,

      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      serviceId: props.sId,
    };

    console.log("data", data);

    if (props.update) {
      data["stationId"] = props.update.stationId;
    }

    poststationDetails(
      {
        url: "/api/station/",
        method: props.update ? "PUT" : "POST",

        body: data,
      },
      (res) => {
        toast.success(`station Details ${props.update ? "Updated" : "Added"}`);
        props.addForm(false);
      }
    );
  };

  useEffect(() => {
    console.log(props.update);
    if (props.update) {
      setStationName(props.update.stationName);

      setRegionId(props.update.regionId);

      setStationCode(props.update.stationCode);
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Station Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Region Name</label>
                        <select
                          id="calculationType"
                          className="form-control"
                          required
                          value={regionId}
                          onChange={(e) => {
                            setRegionId(e.target.value);
                          }}
                        >
                          <option value="0">Select</option>
                          {regionData &&
                            regionData.map((x) => (
                              <option key={x.regionId} value={x.regionId}>
                                {x.regionName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Station Name</label>
                        <input
                          type={"text"}
                          id={"stationName"}
                          required
                          className="form-control"
                          readOnly={props.update}
                          value={stationName}
                          onChange={(e) => {
                            setStationName(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Station Code </label>
                        <input
                          type={"text"}
                          id={"stationCode"}
                          required
                          className="form-control"
                          value={stationCode}
                          readOnly={props.update}
                          onChange={(e) => {
                            setStationCode(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row text-center">
                    <div className="col-md-12">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default StationDetailsForm;
